export default "__VITE_ASSET__CWuKcuus__"